import { useApolloClient, useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { Application_PM_Statuses_Updated, AuthorizationCheckRequired, eventBus, PmStore } from "@/state";



export interface LookupGroupValue {
  id: string,
  active: string,
  value: string,
  locked: boolean
}

const getLookupGroupValuesQuery = gql`
  query getLookupGroupValues($organizationId: UUID!, $group: String!) {
    lookupGroupValues(organizationId: $organizationId, group: $group) {
      id
      active
      value
      locked
    }
  }
`;



const gqlGetLookupValue = gql`
  query lookupValueOrg($organizationId: UUID!, $id: UUID!) {
    lookupValueOrg(organizationId: $organizationId, id: $id) 
  }
`;

const mutationAddGroupValue = gql`
  mutation addGroupValue($organizationId: UUID!, $group: String!, $value: String!) {
    addGroupValue(organizationId: $organizationId, group: $group, value: $value) {
      id
      active
      value
      locked
    }
  }
`;


const mutationRemoveGroupValue = gql`
  mutation removeGroupValue($organizationId: UUID!, $groupValueId: UUID!) {
    removeGroupValue(organizationId: $organizationId, groupValueId: $groupValueId){
      id
      active
      value
      locked
    }
  }  
`;

export function apiRemoveLookupGroupValue(organizationId, groupValueId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .mutate({
                mutation: query,
                variables: {organizationId, groupValueId},
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.removeGroupValue);
                eventBus.next({type:Application_PM_Statuses_Updated})
            })
            .catch((err) => {
                toast.error("Api Error, Unable to add group value");
                reject(err); // R
            })
    });
}






export function useLookupActions() {
    const state = PmStore();

    const [apiLookupGroupValuesQueryAppStatus] = useLazyQuery(getLookupGroupValuesQuery);

    const [apiLookupGroupValuesQueryPM] = useLazyQuery(getLookupGroupValuesQuery);

    const [apiLookupGroupValuesQuery] = useLazyQuery(getLookupGroupValuesQuery);
    const [apiGetLookupValue] = useLazyQuery(gqlGetLookupValue);
    const [apiAddGroupValue] = useMutation(mutationAddGroupValue);
    const [apiRemoveGroupValue] = useMutation(mutationRemoveGroupValue);



    async function RemoveGroupValue(groupValueId: string): Promise<LookupGroupValue> {
      let organizationId = state?.selectedOrganization?.id;
      try {
        let result = await apiRemoveGroupValue({ variables: { organizationId, groupValueId} }) as any;
        return result.data.removeGroupValue;
      }
      catch (err) {
        toast.error("Api Error, Unable to remove lookup group value.");
      }
     
    }

    async function AddGroupValue(group: string, value: string): Promise<LookupGroupValue> {
      let organizationId = state?.selectedOrganization?.id;
      try {
        let result = await apiAddGroupValue({ variables: { organizationId, group, value} }) as any;
        return result.data.addGroupValue;
      }
      catch (err) {
        toast.error("Api Error, Unable to add lookup group value.");
      }
     
    }

   


    function GetLookupValue(organizationId: string, id: string) {
        if(!organizationId) throw "No organization selected";

        return new Promise(async (resolve, reject) => {
            try {
                apiGetLookupValue({variables: { organizationId, id }})
                .then((result: any) => result?.data?.lookupValueOrg)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    

                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                      }

    
                    toast.error("Api Error, Unable to get lookup value");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }

            
        })
    }


   



    async function GetLookupGroupValuesV2( group: string) {
        var  organizationId = state?.selectedOrganization?.id as string
        try {
            let result = await apiLookupGroupValuesQuery({ variables:  {organizationId, group}}) as any;
            return result.data.lookupGroupValues ?? [];
        }
        catch (error) {
            if (error?.name == "AbortError") {
               return await GetLookupGroupValuesV2(group);
            }
            else {
                toast.error("Api Error, Unable to get lookup group");
                throw error;
            }
        }
    }

   
   
    
    return {
        GetLookupValue,
        GetLookupGroupValues: GetLookupGroupValuesV2,
        GetLookupGroupValuesV2,
        GetApplicationPmStatus: async () => await GetLookupGroupValuesV2("application_pm_status"),
        GetApplicationStatuses: async () => await GetLookupGroupValuesV2("application_status"),
        GetNotificationCategories: async () => await GetLookupGroupValuesV2("communication_category"),
        AddGroupValue,
        RemoveGroupValue
    };
}




